import { memo } from 'react';
import type {
  PricePeriodType,
  PriceUnitType
} from '@elfsight/configurator-contracts';
import { useTranslation } from 'react-i18next';
import { TranslateAgnosticPrice } from './translate-agnostic-price';
import type { PriceProps } from './types';

export const I18nPrice = memo(
  ({ pricingModel, unit, period, ...forwardingProps }: PriceProps) => {
    const { t } = useTranslation();
    const postfix = usePriceI18nTranslatedPostfix(
      pricingModel === 'per' ? unit : period
    );
    const freeLabel = t('Free');
    const startingAtLabel = t('Starting at');

    return (
      <TranslateAgnosticPrice
        {...forwardingProps}
        pricingModel={pricingModel}
        freeLabel={freeLabel}
        startingAtLabel={startingAtLabel}
        postfix={postfix}
      />
    );
  }
);

type Postfix = PriceUnitType | PricePeriodType;

const usePriceI18nTranslatedPostfix = (postfix: Postfix) => {
  const { t } = useTranslation();

  const translations: Record<Postfix, string> = {
    day: t('day'),
    gal: t('gal'),
    GB: t('GB', { context: 'Price per unit' }),
    hour: t('hour'),
    item: t('item', { context: 'Price per unit' }),
    kg: t('kg'),
    liter: t('liter'),
    m: t('m'),
    mile: t('mile'),
    month: t('month'),
    oz: t('oz'),
    lb: t('lb'),
    'ft²': t('ft²'),
    'm²': t('m²'),
    week: t('week'),
    year: t('year'),
    quarter: t('quarter'),
    '6 months': t('6 months')
  };

  return translations[postfix];
};
